<!-- Button -->
<button mat-icon-button>
    <span class="relative">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>

        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full"></span>
    </span>
</button>
